




















import Vue from 'vue';
import NavbarComp from '../modules/NavbarComp.vue';
import FooterComp from '../modules/FooterComp.vue';
import ListComp from '../modules/ListComp.vue';
import { APIClient } from '../../libs/ApiClient';

export default Vue.extend({
  name: 'Histories',
  data() {
    return {
      isLoading: true,
      rowsPerPageItems: [10, 25, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      hideActions: false,
      histories: [],
      isShowSearch: true,
    };
  },
  created() {
    this.getApostilles();
  },
  methods: {
    async getApostilles() {
      this.histories = await APIClient.getApostilles();
      this.isLoading = false;
    }
  },
  components: {
    NavbarComp,
    FooterComp,
    ListComp,
  },
});
